import ValidateGlobal from './../../ValidateGlobal.js'
import ServiceGlobal from './../../InputsServiceGlobal.js'
export default {
  mixins: [ValidateGlobal, ServiceGlobal],
  props: {
    config: {
      type: Object
    },
    modelProps: {
      type: Object
    },
    rootModel: {
      type: Object
    },
    parent: {
      type: Object
    }
  },
  model: {
    prop: 'modelProps',
    event: 'input'
  },
  data () {
    return {
      value: this.modelProps,
      splitedValue: ['', '']
    }
  },
  created () {
    this.splitedValue = [this.value[this.config.primaryName], this.value[this.config.subName]]
  },
  watch: {
    splitedValue () {
      let model = {}
      model[this.config.primaryName] = this.splitedValue[0]
      model[this.config.subName] = this.splitedValue[1]
      this.$emit('input', this._.merge(this.modelProps, model))
    }
  },
  computed: {
    validationRules () {
      return this.expressionResolver(this.config.validation)
    }
  },
  methods: {
    onBlur () {},
    validate () {
      this.$refs[this._uid].$emit('submitEvent', this.splitedValue[0])
      this.$refs[this._uid + '-sub'].$emit('submitEvent', this.splitedValue[1])
    }
  }
}
